import {type VFC, useCallback, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {setOnPageDataLayer} from '../../../../utils/analytics.js';
import {ROUTE_PATHS} from '../../../../utils/constants/public/psr.js';
import {
  sessionStorageGetItem,
  WebStorageProperties,
} from '../../../../utils/session.js';

type Props = Record<string, never>;

const PageLevelTagging: VFC<Props> = () => {
  const {pathname} = useLocation();

  const customerSelection = JSON.parse(
    JSON.stringify(sessionStorageGetItem(WebStorageProperties.QuoteRequest))
  );

  const handlePageTagging = useCallback(() => {
    switch (pathname) {
      case ROUTE_PATHS.PAYMENT_SYSTEMS_REGULATOR_PATH:
        setOnPageDataLayer({
          journeyStep: [1, 'About Your Business'],
          journeyStatus: ['undefined', 'undefined', 'Application'],
          journeyProduct: ['undefined', 'undefined', 'undefined'],
          journeyAmount: undefined,
          journeyProductRate: 'undefined',
          journeyProductTerm: 'undefined',
        });
        break;
      case ROUTE_PATHS.PAYMENT_SYSTEMS_OUTPUT_PAGE_PATH:
        setOnPageDataLayer({
          journeyStep: [2, 'Quote Summary'],
          journeyStatus: [
            'Configuration',
            `[${customerSelection.checkedPaymentType}]`,
            'Fulfilled',
          ],
          journeyProduct: [
            `${customerSelection.industry}`,
            `${customerSelection.sector}`,
            `${customerSelection.pciDss}`,
          ],
          journeyAmount: customerSelection.card_turn_over,
          journeyProductRate: `${customerSelection.faceToFacePercentage}`,
          journeyProductTerm: `${customerSelection.average_card_payment}`,
        });
        break;
      case ROUTE_PATHS.DECLINE_TO_QUOTE_PATH:
        setOnPageDataLayer({
          journeyStep: [2, 'Ineligible'],
          journeyStatus: ['Customer Ineligible', 'MCC Ineligible', 'Declined'],
          journeyProduct: [
            `${customerSelection.industry}`,
            `${customerSelection.sector}`,
            `${customerSelection.pciDss}`,
          ],
          journeyAmount: customerSelection.card_turn_over,
          journeyProductRate: `${customerSelection.faceToFacePercentage}`,
          journeyProductTerm: `${customerSelection.average_card_payment}`,
        });
        break;
    }
  }, [customerSelection, pathname]);

  useEffect(() => {
    handlePageTagging();
  }, [handlePageTagging]);

  return null;
};

export default PageLevelTagging;
